export default __webpack_public_path__ + "static/media/ChitPro_logo.fc198c38.svg";